export default __webpack_public_path__ + "assets/0f19af637e15427aa5da107dbe0c47b2.png";